/* global LANG, $ */

const $dateSelect = $('.js-date-select');
const $clearDateSelect = $('.js-clear-date-select');
const $output = $('.js-date-select-output');
const $modal = $('#date-select');
const $submit = $('.js-date-select-submit');

const dateSelectModal = {
  initialize() {
    if ($dateSelect.length) {
      this.createEvents();
      const fields = this.getFields();
      this.toggleSubmitButton(this.checkValidity(fields));
      this.toggleClearDateButton();
    }
  },

  /**
   * Create events for date select
   * @return {void}
   */
  createEvents() {
    // Listen for clicks on the button or input field that opens the modal
    $dateSelect.on('click', () => {
      $modal.modal('show');
    });

    // Listen for submissions in the date select modal
    $submit.on('click', () => {
      // Get the begin and end date from the modal
      const fields = this.getFields();

      // Output dates to the input field
      this.setOutput(fields);

      // We're done, let's hide the modal
      $modal.modal('hide');
      this.toggleClearDateButton();
    });

    // Listen for changes on the input fields in the modal (most likely by datepicker)
    $modal.on('change', 'input', () => {
      // Get the begin and end date from the modal
      const fields = this.getFields();

      // Check if the submit button should be available
      this.toggleSubmitButton(this.checkValidity(fields));
    });
  },

  /**
   * Returns the begin and end date from the modal as object
   * @return {Object}
   */
  getFields() {
    // Get all begin and end fields from the modal
    const $fields = $modal.find('[name="begin"], [name="end"]');
    const fields = {};

    // Loop through fields and store the values in the fields object
    $fields.toArray().forEach((field) => {
      fields[field.getAttribute('name')] = field.value;
    });

    return fields;
  },

  /**
   * Check if both the begin and end date are entered
   * @param {Object} fields Object containing begin and end
   * @return {Boolean}
   */
  checkValidity(fields) {
    return (fields.begin && fields.end);
  },

  /**
   * Toggle the submit button disabled/enabled
   * @param {Boolean} state True to enable, false to enable
   * @return {void}
   */
  toggleSubmitButton(state) {
    $submit.prop('disabled', state ? false : 'disabled');
  },

  /**
   * Output begin and end date to the input field
   * @param {Object} fields Object containing the begin and end date
   * @return {void}
   */
  setOutput(fields) {
    const str = `${fields.begin} ${LANG.till} ${fields.end}`;

    // Output and trigger keyup for the filter to re-run
    $output.val(str).trigger('keyup');
  },

  toggleClearDateButton() {
    $clearDateSelect.removeClass('is-open');

    if ($dateSelect.val() !== '') {
      $clearDateSelect.addClass('is-open');

      this.clearDateFilter();
    }
  },

  clearDateFilter() {
    $clearDateSelect.on('click', () => {
      $dateSelect.val('');

      this.toggleClearDateButton();
    });
  },
};

export default dateSelectModal;
